import React, { useEffect } from 'react'

export const Q = () => {
  useEffect(() => {
    
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Android detection
  if (/android/i.test(userAgent)) {
    window.location.href = "https://play.google.com/store/apps/details?id=com.hammadrao.MyApp";
  } 
  
  // iOS detection (iPhone, iPod, iPad)
  else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    window.location.href = "https://apps.apple.com/pk/app/discownty/id6757960111";
  }
}, []);
  
    return ;
}
